module.exports = __webpack_public_path__ + "fonts/display-ultralight.5569b01e.woff";